// JsFromRoutes CacheKey cc212bbc56b30cb329780b7b327e4ec8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/analytics'),
}
